import { Link } from "react-router-dom";
import { useState } from "react";
import { Home, FileText, ClipboardList, Menu, X } from "lucide-react";
import "../style/SubMenu.css";

export default function SubMenu() {
  const [open, setOpen] = useState(false);

  return (
    <div className="sub-menu-container">
   {/* 🔵 HEADER WITH MENU LEFT + LOGO RIGHT */}
      <div className="sub-menu-header">
        <button className="menu-toggle" onClick={() => setOpen(!open)}>
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
        <div className={`sub-menu ${open ? "open" : ""}`}>
        <Link to="/" onClick={() => setOpen(false)}>
          <Home size={20} /> Home
        </Link>

        <Link to="/GrievanceForm" onClick={() => setOpen(false)}>
          <FileText size={20} /> Grievance
        </Link>

        <Link to="/Privacy-policy" onClick={() => setOpen(false)}>
          <ClipboardList size={20} /> Privacy Policy
        </Link>

        <Link to="/constituencies" onClick={() => setOpen(false)}>
          <ClipboardList size={20} /> AP Constituency
        </Link>
      </div>

        {/* 🔵 Your Logo (Right Side) */}
        <img
          src="/uploads/2025/07/New-Project-12-1.png"    // change to your actual logo path
          alt="Logo"
          className="header-logo"
        />
      </div>

      {/* MENU LIST */}
      
    </div>
  );
}
